const headerTop = document.querySelector(".header__top");
const searchForm = document.querySelector(".header__top-search-form");
const searchInput = document.querySelector(".header__search-input");
const searchIcon = document.querySelector(".header__top-search-icon");
const headerLogo = document.querySelector(".header__logo");
const searchModal = document.querySelector(".search-modal");
const closeBtn = document.querySelector(".search-modal__close");

export function initSearch() {
  if (!searchForm) return;

  searchForm.addEventListener("click", addSearch);

  document.addEventListener("click", handleOutsideClick);
}

searchForm.addEventListener("submit", function (event) {
  event.preventDefault();
});

function addSearch() {
  headerTop.classList.add("search");
  searchInput.focus();

  if (window.innerWidth < 650) {
    headerLogo.style.display = "none";
  }
}

function handleOutsideClick(event) {
  if (!searchForm.contains(event.target)) {
    headerTop.classList.remove("search");
    searchInput.value = "";
    searchInput.blur();

    if (searchModal) {
      searchModal.style.display = "none";
    }

    headerLogo.style.display = "block";
  }
}

if (closeBtn) {
  closeBtn.addEventListener("click", () => {
    searchModal.style.display = "none";
    headerLogo.style.display = "block";
  });
}
